module.exports = __webpack_public_path__ + "img/full4-min.f30a6bdf.png";